import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { synonyms } from '@services/api'

export class synonymsStore extends StoreExt {
    @observable compareKeyword = null
    @observable indexedKeywords = {}
    @observable filteredList = []
    @observable filters: any = {}
    @observable keywordsEdit = null
    @observable list = []
    @observable pendingKeywords = []
    @observable termsFilters: any = {}
    @observable termsList = []
    @observable filteredTerms = []

    @action
    getSynonymsList = async () => {
        const { list, index } = (await synonyms.getList()).data
        runInAction(() => {
            this.list = list
            this.indexedKeywords = index
        })
    }

    @action
    search = async keywords => {
        const { list, index } = (await synonyms.search({ keywords })).data
        runInAction(() => {
            this.list = list
            this.indexedKeywords = index
        })
    }

    @action
    addTermFilter = (name, value) => {
        const newFilters = { ...this.termsFilters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.termsFilters = { ...newFilters }
            this.applyTermFilters()
        })
    }

    @action
    applyTermFilters = () => {
        const newList = this.termsList.filter(item => {
            let filter = true
            if ('freeSearch' in this.termsFilters) {
                if (item.name)
                    filter = item.name
                        .replace('"', '')
                        .toLowerCase()
                        .includes(this.termsFilters['freeSearch'].toLowerCase())
            }
            return filter
        })
        runInAction(() => {
            this.filteredTerms = newList
        })
    }

    @action
    getTermsList = async dataType => {
        const list = (await synonyms.getTerms({ dataType })).data
        runInAction(() => {
            this.termsList = list
            this.resetTermsFilters()
        })
    }

    @action
    resetTermsFilters = () => {
        this.termsFilters = {}
        this.filteredTerms = [...this.termsList]
        this.applyTermFilters()
    }

    @action
    applyFilters = () => {
        const newList = this.list.filter(item => {
            let filter = true
            if ('freeSearch' in this.filters) {
                if (item.name) filter = item.name.toLowerCase().includes(this.filters['freeSearch'].toLowerCase())
                if (item.keywords)
                    filter = item.keywords.toLowerCase().includes(this.filters['freeSearch'].toLowerCase())
            }
            return filter
        })
        runInAction(() => {
            this.filteredList = newList
        })
    }

    @action
    addFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
            this.applyFilters()
        })
    }

    @action
    addPendingKeyword = keyword => {
        const newKeywords = [...this.pendingKeywords, keyword]
        runInAction(() => {
            this.pendingKeywords = newKeywords
        })
    }

    @action
    removePendingKeyword = keyword => {
        const newKeywords = [...this.pendingKeywords].filter(key => key !== keyword)
        runInAction(() => {
            this.pendingKeywords = newKeywords
        })
    }

    @action
    removeKeyword = async item => {
        const { keywords: oldKeywords, keyword } = item
        const keywords = oldKeywords
            .split(',')
            .filter(key => key !== keyword)
            .join(',')
        await synonyms.updateSynonym({ ...item, keywords })
        await this.getSynonymsList()
        this.applyFilters()
        this.resetEdit()
    }

    @action
    toggleKeywordsEdit = value => {
        if (value === this.keywordsEdit) {
            this.keywordsEdit = null
            this.pendingKeywords = []
        } else {
            this.keywordsEdit = value
        }
    }

    @action
    toggleCompareKeyword = value => {
        this.compareKeyword = value
    }

    @action
    updateSynonym = async groupData => {
        let keywords = groupData.keywords
        if (this.pendingKeywords.length > 0)
            keywords = `${groupData.keywords ? `${groupData.keywords}, ` : ''}${this.pendingKeywords.join(', ')}`
        const name =
            'name' in groupData && groupData.name ? groupData['name'] : this.pendingKeywords[0].replace('_', ' ')
        await synonyms.updateSynonym({ ...groupData, keywords, name })
        this.resetEdit()
    }

    @action
    addSynonymGroup = async groupData => {
        const keywords = this.pendingKeywords.length > 0 ? this.pendingKeywords.join(', ') : null
        await synonyms.addSynonym({ ...groupData, keywords })
        this.resetEdit()
    }

    @action
    removeSynonymGroup = async id => {
        await synonyms.deleteSynonym(id)
        await this.getSynonymsList()
        this.applyFilters()
        this.resetEdit()
    }

    @action
    resetFilters = () => {
        this.filters = {}
        this.applyFilters()
    }

    @action
    resetEdit = () => {
        this.pendingKeywords = []
        this.keywordsEdit = null
    }

    @action
    resetSynonyms = () => {
        this.list = []
        this.filteredList = []
        this.pendingKeywords = []
    }
}

export default remotedev(new synonymsStore())
